import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss']
})
export class TimePickerComponent implements OnInit {
  @Input() timeInputObservable: Observable<any>;
  @Input() defaultTime: any;
  @Output() onTimeChanged: EventEmitter<any> = new EventEmitter<any>();

  startHour: string;
  startMinutes: string;
  endHour: string;
  endMinutes: string;

  constructor() { }

  ngOnInit() {
    this.setTimes();
    this.subscribeTimes();
  }

  subscribeTimes(): void {
    this.timeInputObservable.subscribe((value: any) => {
      this.startHour = value.startHour;
      this.startMinutes = value.startMinutes;
      this.endHour = value.endHour;
      this.endMinutes = value.endMinutes;
      this.timesChanged();
    });
  }

  setTimes(): void {
    if (this.defaultTime) {
      this.startHour = this.defaultTime.startHour;
      this.startMinutes = this.defaultTime.startMinutes;
      this.endHour = this.defaultTime.endHour;
      this.endMinutes = this.defaultTime.endMinutes;
      this.timesChanged();
      return;
    }
    this.startHour = '00';
    this.startMinutes = '00';
    this.endHour = '23';
    this.endMinutes = '59';
  }

  timesChanged(): void {
    let exportTime = {
      startHour: this.startHour,
      startMinutes: this.startMinutes,
      endHour: this.endHour,
      endMinutes: this.endMinutes
    };
    this.onTimeChanged.emit(exportTime);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/time-picker/time-picker.component.ts